"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItpDropdownText = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
let ItpDropdownText = class ItpDropdownText extends vue_property_decorator_1.Vue {
    text;
    data() {
        return {
            className: 'mx-3 text-muted mb-1'
        };
    }
};
exports.ItpDropdownText = ItpDropdownText;
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpDropdownText.prototype, "text", void 0);
exports.ItpDropdownText = ItpDropdownText = __decorate([
    (0, vue_property_decorator_1.Component)({
        template: '<p :class="className"><slot>{{ text }}</slot></p>'
    })
], ItpDropdownText);
//# sourceMappingURL=dropdown-text.js.map